export default "__VITE_ASSET__4d555262__"